// Application Constants
// Currency
export const CURRENCY = 'PEN';
export const CURRENCY_SYMBOL = 'S/';
export const CURRENCY_LOCALE = 'es-PE';
// Pagination defaults
export const DEFAULT_PAGE_SIZE = 24;
export const MAX_PAGE_SIZE = 100;
export const FILTER_BATCH_MULTIPLIER = 5; // Multiplier for batch size when aggregating filter options
// Cache TTLs (in seconds)
export const CACHE_TTL = {
    PRODUCTS: 300, // 5 minutes
    PRODUCT_DETAIL: 300, // 5 minutes
    STOCK: 30, // 30 seconds
    PRICES: 300, // 5 minutes
    CONFIGURATION: 3600, // 1 hour
    SEARCH_RESULTS: 300, // 5 minutes
    AI_CONVERSATION: 86400, // 24 hours
};
// Bsale API
export const BSALE_API_BASE_URL = 'https://api.bsale.io';
export const BSALE_API_VERSION = 'v1';
export const BSALE_RATE_LIMIT = 100; // requests per minute
// Bsale Checkout States
export const BSALE_CHECKOUT_STATE = {
    PENDING: 0,
    PROCESSING: 1,
    COMPLETED: 2,
    FAILED: 3,
};
// Product categories
export const PRODUCT_CATEGORIES = [
    { id: 'perros', name: 'Perros', slug: 'perros' },
    { id: 'gatos', name: 'Gatos', slug: 'gatos' },
    { id: 'prendas', name: 'Prendas', slug: 'prendas' },
    { id: 'placas', name: 'Placas', slug: 'placas' },
    { id: 'farmacia', name: 'Farmacia', slug: 'farmacia' },
    { id: 'outlet', name: 'Outlet', slug: 'outlet' },
];
// Navigation
export const MAIN_NAV_ITEMS = [
    { label: 'Perros', href: '/perros' },
    { label: 'Gatos', href: '/gatos' },
    { label: 'Prendas', href: '/prendas' },
    { label: 'Placas', href: '/placas' },
    { label: 'Farmacia', href: '/farmacia' },
    { label: 'Outlet', href: '/outlet' },
];
// AI Scoring weights
export const AI_SCORING_WEIGHTS = {
    RELEVANCE: 0.50, // 50%
    MARGIN: 0.20, // 20%
    STOCK: 0.15, // 15%
    POPULARITY: 0.10, // 10%
    RECENCY: 0.05, // 5%
};
// AI Providers
export const AI_PROVIDERS = {
    CLOUDFLARE: 'cloudflare',
    OPENAI: 'openai',
    ANTHROPIC: 'anthropic',
    GROK: 'grok',
    GLM: 'glm',
};
// AI Models
export const AI_MODELS = {
    CLOUDFLARE_LLAMA: '@cf/meta/llama-3.1-8b-instruct',
    OPENAI_GPT4O_MINI: 'gpt-4o-mini',
    OPENAI_GPT4O: 'gpt-4o',
    ANTHROPIC_CLAUDE_SONNET: 'claude-3-5-sonnet-20241022',
    GROK_2: 'grok-2',
    GLM_4: 'glm-4',
};
// Problem categories for AI
export const PROBLEM_CATEGORIES = {
    SKIN: 'Problemas de piel',
    DIGESTIVE: 'Problemas digestivos',
    JOINT: 'Problemas articulares',
    DENTAL: 'Problemas dentales',
    WEIGHT: 'Problemas de peso',
    ANXIETY: 'Ansiedad/Comportamiento',
    GENERAL_HEALTH: 'Salud general',
    GROOMING: 'Cuidado estético',
    NUTRITION: 'Nutrición',
    TRAINING: 'Entrenamiento',
    OTHER: 'Otro',
};
// Order statuses
export const ORDER_STATUSES = {
    PENDING: 'pending',
    CONFIRMED: 'confirmed',
    PAID: 'paid',
    PROCESSING: 'processing',
    SHIPPED: 'shipped',
    DELIVERED: 'delivered',
    CANCELLED: 'cancelled',
};
// Payment methods
export const PAYMENT_METHODS = {
    CASH: 'cash',
    CARD: 'card',
    YAPE: 'yape',
    PLIN: 'plin',
    TRANSFER: 'transfer',
};
// Document types (Peru)
export const DOCUMENT_TYPES = {
    DNI: 'dni',
    RUC: 'ruc',
    CE: 'ce',
};
// Tax rate (Peru IGV)
export const IGV_RATE = 0.18;
// HTTP Status Codes
export const HTTP_STATUS = {
    OK: 200,
    CREATED: 201,
    NO_CONTENT: 204,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    UNPROCESSABLE_ENTITY: 422,
    TOO_MANY_REQUESTS: 429,
    INTERNAL_SERVER_ERROR: 500,
    BAD_GATEWAY: 502,
    SERVICE_UNAVAILABLE: 503,
};
// Error codes
export const ERROR_CODES = {
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    NOT_FOUND: 'NOT_FOUND',
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    RATE_LIMITED: 'RATE_LIMITED',
    BSALE_API_ERROR: 'BSALE_API_ERROR',
    AI_PROVIDER_ERROR: 'AI_PROVIDER_ERROR',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    CART_EMPTY: 'CART_EMPTY',
    INSUFFICIENT_STOCK: 'INSUFFICIENT_STOCK',
    PAYMENT_FAILED: 'PAYMENT_FAILED',
};
// Webhook topics
export const WEBHOOK_TOPICS = {
    DOCUMENT_CREATED: 'document.created',
    DOCUMENT_UPDATED: 'document.updated',
    DOCUMENT_DELETED: 'document.deleted',
    DOCUMENT_INFORMED: 'document.informed',
    STOCK_UPDATED: 'stock.updated',
    STOCK_RECEPTION: 'stock.reception',
    STOCK_CONSUMPTION: 'stock.consumption',
    PRODUCT_CREATED: 'product.created',
    PRODUCT_UPDATED: 'product.updated',
    PRODUCT_DELETED: 'product.deleted',
    VARIANT_CREATED: 'variant.created',
    VARIANT_UPDATED: 'variant.updated',
    VARIANT_DELETED: 'variant.deleted',
    PRICE_UPDATED: 'price.updated',
    ONLINE_SALE_CREATED: 'online_sale.created',
    ONLINE_SALE_PAID: 'online_sale.paid',
    ONLINE_SALE_SHIPPED: 'online_sale.shipped',
    ONLINE_SALE_CANCELLED: 'online_sale.cancelled',
};
// Retry configuration
export const RETRY_CONFIG = {
    MAX_RETRIES: 3,
    INITIAL_DELAY_MS: 1000,
    MAX_DELAY_MS: 10000,
    BACKOFF_MULTIPLIER: 2,
};
// Time constants
export const ONE_SECOND_MS = 1000;
export const ONE_MINUTE_MS = 60 * ONE_SECOND_MS;
export const ONE_HOUR_MS = 60 * ONE_MINUTE_MS;
export const ONE_DAY_MS = 24 * ONE_HOUR_MS;
// Common cache/stale time durations
export const FIVE_MINUTES_MS = 5 * ONE_MINUTE_MS;
export const THIRTY_SECONDS_MS = 30 * ONE_SECOND_MS;
// Authentication
export const ACCESS_TOKEN_LIFETIME_MS = 15 * ONE_MINUTE_MS; // 15 minutes
export const REFRESH_TOKEN_SLIDING_WINDOW_MS = 7 * ONE_DAY_MS; // 7 days
export const MAX_FAILED_LOGIN_ATTEMPTS = 5;
export const ACCOUNT_LOCKOUT_DURATION_MS = 30 * ONE_MINUTE_MS; // 30 minutes
export const MIN_PASSWORD_LENGTH = 8;
export const BCRYPT_SALT_ROUNDS = 10;
export const TOKEN_LENGTH_BYTES = 32;
export const EMAIL_VERIFICATION_TOKEN_EXPIRY_MS = 24 * ONE_HOUR_MS; // 24 hours
export const PASSWORD_RESET_TOKEN_EXPIRY_MS = ONE_HOUR_MS; // 1 hour
// Auth error codes
export const AUTH_ERROR_CODES = {
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
    EMAIL_NOT_VERIFIED: 'EMAIL_NOT_VERIFIED',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    TOKEN_INVALID: 'TOKEN_INVALID',
    TOKEN_REUSED: 'TOKEN_REUSED',
    PASSWORD_TOO_WEAK: 'PASSWORD_TOO_WEAK',
    EMAIL_ALREADY_EXISTS: 'EMAIL_ALREADY_EXISTS',
};
// UI Constants
export const UI_CONSTANTS = {
    MAX_CART_DISPLAY: 99,
    MAX_QUANTITY_PER_ITEM: 999,
    DEBOUNCE_DELAY_MS: 500,
    ANIMATION_DURATION_MS: 300,
    TOAST_DURATION_MS: 3000,
    NOTIFICATION_DELAY_MS: 2000,
    STAGGER_DELAY_MS: 100,
    COUNT_UP_DURATION_MS: 1000,
    COUNT_UP_ALT_DURATION_MS: 1800,
    COUNT_UP_LONG_DURATION_MS: 2000,
    PRODUCTS_PER_ROW: 4,
    FEATURED_PRODUCTS_LIMIT: 8,
    RELATED_PRODUCTS_LIMIT: 4,
    SIMILAR_PRODUCTS_LIMIT: 5,
    RECOMMENDATIONS_LIMIT: 8,
    MAX_SUGGESTIONS_LIMIT: 3,
    DEFAULT_BUTTON_WIDTH: 400,
    HERO_AUTOPLAY_INTERVAL_MS: 5000,
};
// Checkout Constants
export const CHECKOUT_CONSTANTS = {
    DEFAULT_FREE_SHIPPING_THRESHOLD: 150,
    DEFAULT_MAX_CART_QUANTITY: 5,
    CARD_NUMBER_LENGTH: 16,
    CARD_CVV_LENGTH: 3,
    SHIPPING_STEPS: 3,
};
// AI Constants
export const AI_CONSTANTS = {
    DEFAULT_TEMPERATURE: 0.7,
    DEFAULT_MAX_TOKENS: 500,
    DEFAULT_PRIORITY_SCORE: 50,
    PRICE_BUCKET_LOW: 50,
    PRICE_BUCKET_MID: 100,
    PRICE_BUCKET_HIGH: 200,
    MIN_SIMILARITY_THRESHOLD: 0.3,
    HIGH_SIMILARITY_THRESHOLD: 0.5,
    MARGIN_THRESHOLD: 0.7,
    CONVERSATION_HISTORY_LIMIT: 1000,
    MAX_RETRIES: 3,
    RETRY_DELAY_SECONDS: 60,
};
// Validation Constants
export const VALIDATION_CONSTANTS = {
    MAX_NAME_LENGTH: 100,
    MAX_DESCRIPTION_LENGTH: 500,
    MAX_MESSAGE_LENGTH: 2000,
    MAX_EMAIL_LENGTH: 200,
    MAX_PHONE_LENGTH: 20,
    MAX_ADDRESS_LENGTH: 500,
    MIN_ADDRESS_LENGTH: 5,
    MIN_CITY_LENGTH: 2,
    MIN_PASSWORD_LENGTH: 8,
    MAX_SEARCH_QUERY_LENGTH: 100,
    PRODUCTS_PER_PAGE_DEFAULT: 24,
    MAX_PRODUCTS_PER_PAGE: 100,
    PAGE_SIZE_SMALL: 25,
    PAGE_SIZE_MEDIUM: 50,
    // Device metadata limits
    MAX_DEVICE_TYPE_LENGTH: 50,
    MAX_BROWSER_LENGTH: 100,
    MAX_OS_LENGTH: 50,
    MAX_SCREEN_RESOLUTION_LENGTH: 20,
    MAX_TIMEZONE_LENGTH: 50,
    MAX_LANGUAGE_LENGTH: 10,
    // Tracking limits
    MAX_PRODUCT_ID_LENGTH: 50,
    MAX_VARIANT_ID_LENGTH: 50,
    MAX_RESULTS_COUNT: 10000,
    MAX_QUANTITY: 1000,
    MAX_CONVERSATION_MESSAGES: 100,
    MAX_DURATION_SECONDS: 86400,
    MAX_NOTES_LENGTH: 500,
    MAX_OUTCOME_LENGTH: 50,
    MAX_CONVERSATION_ID_LENGTH: 100,
};
// CORS Constants
export const CORS_MAX_AGE_SECONDS = 86400;
// Cart Constants
export const CART_CONSTANTS = {
    PRICE_MULTIPLIER: 100,
    PROGRESS_PERCENTAGE_FULL: 100,
};
// Test Constants (for use in test files)
export const TEST_CONSTANTS = {
    MOCK_ID: 123,
    MOCK_ID_ALT: 456,
    MOCK_ID_LARGE: 789,
    MOCK_QUANTITY: 5,
    MOCK_QUANTITY_LARGE: 10,
    MOCK_PRICE: 100,
    MOCK_PRICE_SMALL: 50,
    MOCK_PRICE_LARGE: 500,
    MOCK_FAILED_ATTEMPTS: 3,
    TOKEN_EXPIRY_MS: 900000, // 15 minutes in ms
    REFRESH_CHECK_INTERVAL_MS: 30000,
    REFRESH_THRESHOLD_MS: 14 * 60 * 1000, // 14 minutes
    PAGE_SIZE_SMALL: 25,
};
// Bearer token prefix length (for slicing "Bearer " from auth header)
export const BEARER_PREFIX_LENGTH = 7;
// Rate Limiting Constants
export const RATE_LIMIT_WINDOW_MS = 15 * ONE_MINUTE_MS; // 15 minutes
export const RATE_LIMIT_WINDOW_SECONDS = 15 * 60; // 15 minutes in seconds
export const RATE_LIMIT_AUTH_MAX = 5; // Auth endpoints: 5 requests per 15 min (strictest)
export const RATE_LIMIT_STRICT_MAX = 50; // Write operations: 50 requests per 15 min
export const RATE_LIMIT_MODERATE_MAX = 100; // Read operations: 100 requests per 15 min
export const RATE_LIMIT_LIGHT_MAX = 500; // Public endpoints: 500 requests per 15 min
